module.exports = {"description":"","displayName":"PageFooter","methods":[],"props":{"children":{"type":{"name":"node"},"required":false,"description":"PageFooter content"},"cssMap":{"defaultValue":{"value":"require( './pageFooter.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/PageFooter-props.json
// module id = 453
// module chunks = 0